import { usePageTitle } from "hooks/usePageTitle";
import React from "react";
import { useTranslation } from "react-i18next";
import { LmsBanner } from "views/lms/home/LmsBanner";
import { LmsCarousel } from "./LmsCarousel";

export const LmsHome: React.FC = () => {
    const { t } = useTranslation("lms");

    usePageTitle(t("Home.PageTitle"));

    return (
        <div>
            <LmsBanner />

            <LmsCarousel />
        </div>
    );
};
